import GenericModel from '../../generic-model';
import { UrbanPlanningAbbreviation } from './urban-planning-abbreviation';

export class IPBoardPartAbbreviation extends GenericModel {
  abbreviation?: UrbanPlanningAbbreviation;
}
